// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__n6xTs","tab":"Tabs_tab__2TFu9","tabActive":"Tabs_tabActive__2Ia3W"};